interface TaxPayerApiKey {
  id?: number;
  taxPayerId?: number;
  keyName?: string;
  keyPrefix?: string;
  isActive?: boolean;
  permissions?: string[];
  expiresAt?: string;
  createdAt?: string;
  rawKey?: string; // only returned once on creation
}

export const PUBLIC_API_PERMISSION_LIST: { value: string; label: string; group: string }[] = [
  { value: "read_invoices", label: "Leer Facturas", group: "Facturas" },
  { value: "write_invoices", label: "Escribir Facturas", group: "Facturas" },
  { value: "read_receipts", label: "Leer Recibos", group: "Recibos" },
  { value: "write_receipts", label: "Escribir Recibos", group: "Recibos" },
  { value: "read_credit_notes", label: "Leer Notas de Crédito", group: "Notas de Crédito" },
  { value: "write_credit_notes", label: "Escribir Notas de Crédito", group: "Notas de Crédito" },
  { value: "read_debit_notes", label: "Leer Notas de Débito", group: "Notas de Débito" },
  { value: "write_debit_notes", label: "Escribir Notas de Débito", group: "Notas de Débito" },
  { value: "read_remission_notes", label: "Leer Notas de Remisión", group: "Notas de Remisión" },
  { value: "write_remission_notes", label: "Escribir Notas de Remisión", group: "Notas de Remisión" },
  { value: "read_auto_invoices", label: "Leer Autofacturas", group: "Autofacturas" },
  { value: "write_auto_invoices", label: "Escribir Autofacturas", group: "Autofacturas" },
  { value: "read_stamps", label: "Leer Timbrados", group: "Timbrados" },
  { value: "write_stamps", label: "Escribir Timbrados", group: "Timbrados" },
  { value: "read_clients", label: "Leer Clientes", group: "Clientes" },
  { value: "write_clients", label: "Escribir Clientes", group: "Clientes" },
  { value: "read_establishments", label: "Leer Establecimientos", group: "Establecimientos" },
  { value: "write_establishments", label: "Escribir Establecimientos", group: "Establecimientos" },
  { value: "read_dispatch_points", label: "Leer Puntos de Expedición", group: "Puntos de Expedición" },
  { value: "write_dispatch_points", label: "Escribir Puntos de Expedición", group: "Puntos de Expedición" },
  { value: "read_taxpayer", label: "Leer Contribuyente", group: "Contribuyente" },
  { value: "read_received_documents", label: "Leer Documentos Recibidos", group: "Documentos Recibidos" },
  { value: "write_received_documents", label: "Escribir Documentos Recibidos", group: "Documentos Recibidos" },
];

export const newTaxPayerApiKey = (taxPayerId?: number): TaxPayerApiKey => {
  return {
    taxPayerId: taxPayerId,
    permissions: [],
  };
};

export default TaxPayerApiKey;
